import { useQueryString } from 'hooks';

const useTeamFilter = () => {
  const [filteredIds, setFilteredIds] = useQueryString('teams', undefined);

  return [filteredIds, setFilteredIds];
};

export default useTeamFilter;
